module.exports = __webpack_public_path__ + "img/background-dots-md.fa8ded5.jpg";